export class CompareVersionString {
  static isHigher(currentVersion: string, versionToCompare: string): boolean {
    return currentVersion.localeCompare(versionToCompare, undefined, {numeric: true, sensitivity: 'base'}) === 1;
  }

}
